import {
  Component,
  OnInit,
  ViewChild,
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';
import { Router } from '@angular/router';
import { StateService } from '../../../common/services/state.service';
import { ActivatedRoute } from '@angular/router';
import { CheckoutService } from '../../../checkout/services/checkout.service';
import { OrderService } from '../../../orders/services/order.service';
import { Order } from '../../../orders/models/order';
import { User } from '../../../common/models/user';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { ErrorService } from '../../../common/services/error.service';

@Component({
    selector: 'app-stripe-error',
    templateUrl: './stripe-error.component.html',
    styleUrls: ['./stripe-error.component.sass'],
    standalone: false
})
export class StripeErrorComponent implements OnInit {
  baseUrl: string = environment.sgc.apiUrl;

  constructor(
    private route: ActivatedRoute,
    private orderService: OrderService,
    private router: Router,
    private checkoutService: CheckoutService,
    private stateService: StateService,
    private formBuilder: FormBuilder,
    private errorService: ErrorService
  ) {}

  invoiceOrderId: any;
  order = new Order();
  currentUser = new User();
  form?: FormGroup;
  email = '^[^@]+@[a-zA-Z0-9._-]+\\.+[a-z._-]+$';
  isSubmitting = false;
  emailsentmsg: any;
  isemailsent: boolean = false;
  paypalExecptionMsg: any;

  ngOnInit() {
    this.errorService.paypalExecption$.subscribe(
      (x:any) => (this.paypalExecptionMsg = x)
    );
    this.form = this.formBuilder.group({
      orderNumber: new FormControl(
        '',
        Validators.compose([
          Validators.pattern('^[0-9]*$'),
          Validators.required,
        ])
      ),
      name: new FormControl(
        null,
        Validators.compose([
          Validators.pattern('^[a-zA-Z,.!? ]*$'),
          Validators.maxLength(100),
          Validators.required,
        ])
      ),
      email: new FormControl(
        null,
        Validators.compose([
          Validators.pattern(this.email),
          Validators.required,
        ])
      ),
      phone: new FormControl('', Validators.required),
      alternatePhone: new FormControl(''),
      comments: new FormControl(''),
    });

    var orderId = this.getOrderId();
    this.invoiceOrderId = orderId;
    if (!orderId) return;
    this.checkoutService.currentOrder$.subscribe((order) => {
      this.order = order;
      if (this.form) {
        const orderNumberControl = this.form.get('orderNumber');
        const nameControl = this.form.get('name');
        const emailControl = this.form.get('email');
        const phoneControl = this.form.get('phone');

        if (orderNumberControl) {
          orderNumberControl.setValue(this.order.publicId);
        }

        if (nameControl) {
          nameControl.setValue(this.order.customer.user.name);
        }

        if (emailControl) {
          emailControl.setValue(this.order.customer.user.email);
        }

        if (phoneControl) {
          phoneControl.setValue(this.order.customer.phoneNumber);
        }
      }
    });
    this.currentUser = this.stateService.currentUser.get();
  }

  startNewSubmission() {
    this.router.navigate(['/checkout']);
  }

  mySubmission() {
    this.router.navigate(['/account/myorder']);
  }

  getOrderId() {
    if (!this.route.snapshot.params) return null;
    return this.route.snapshot.params['id'];
  }
}
